<!-- ExtraiDadosBasico.svelte -->
<script>
    import { onMount } from "svelte";
    import { Card, Accordion, Button, Text, Image } from "@svelteuidev/core";
    import Conexoes from "../../Classes/Conexoes.js";
    import ExibeItem from "../../Classes/exibeItem.js";

    import Loading from "../../componentes_basicos/Loading.svelte";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Constantes from "../../Classes/Constantes.js";
    import ArmazenaVariaveisLogin from "../../Classes/ArmazenaVariaveisLogin.js";
    import ExibeInscricao from "../../Classes/ExibeInscricao.js";
    import AccordionItem from "../../componentes_basicos/AccordionItem.svelte";
    import ModeloComprovante from "../../componentes_basicos/ModeloComprovante.svelte";

    let api = Constantes.api_consultar_padrao;
    let id_usuario = localStorage.getItem("id_usuario");
    let parametros = {
        id_usuario: id_usuario,
        query_code: Constantes.query_code_consultar_minhas_inscricao,
    };
    let parametros2 = {
        id_usuario: id_usuario,
        query_code: Constantes.query_code_consultar_eventos_incritos,
    };
    let logo1 = Constantes.logo_wodoxi_timbre;
    let inscricao = {};
    let eventos = [];
    let carregando = false;
    let conexoes = new Conexoes();
    let dados = [];
    let paginaAtual = 1;
    const tamanhoPagina = 10;
    let loading = false;
    let eventosInscritos = [];
    let minhasInscricoes = [];
    let iniciou = false;
    let certificado = 0;

    let transaction_amount=0;
    let taxa_pag_cartao=0;
    let taxa_pag_pix=0;
    let taxa_pag_boleto=0;

    export async function conectar() {
        conexoes = new Conexoes();
        carregando = true;

        eventosInscritos = await conexoes.conecta(api, parametros2);
        minhasInscricoes = await conexoes.conecta(api, parametros);
        // Adiciona os novos dados à lista existente
        console.log("minhas inscricoes ", minhasInscricoes);
        console.log("eventos inscritos ", eventosInscritos);

        eventosInscritos.forEach((element) => {
            // Filtra as minhas inscricoes para o nome_campeonato atual
            const inscricoesFiltradas = minhasInscricoes.filter(
                (e) => e.nome_campeonato === element.nome_campeonato,
            );

            // Atribui as inscrições filtradas ao campeonato correspondente
            eventos[element.nome_campeonato] = inscricoesFiltradas;

            console.log(
                `Inscrições para ${element.nome_campeonato}: `,
                inscricoesFiltradas,
            );
        });

        /*
       eventosInscritos.forEach((element) => {
            let inscricoes = [];
            eventos[element.nome_campeonato] = [];
            minhasInscricoes.forEach((e) => {
               
                console.log(e);
                console.log("inscricoes ", inscricoes);

                eventos[element.nome_campeonato] = [
                    ...eventos[element.nome_campeonato],
                    e,
                ];
            });
        });

        */
        console.log("eventos ", eventos);
        carregando = false; // Esconde o ícone de carregamento quando terminar
    }

    // Conectar ao carregar o componente
    onMount(async () => {
        id_usuario = await localStorage.getItem("id_usuario");

        console.log("armazena", localStorage.getItem("id_usuario"));
        conectar();
    });
</script>

<Loading isLoading={carregando} />
{#if eventos}
    <div class="container">
        <h2 class="m-3">Suas inscrições:</h2>
        <div class="card-container">
            <Accordion>
                {#each eventosInscritos as evt, idx}
                    <Accordion.Item value={evt.nome_campeonato}>
                        <div slot="control">{evt.nome_campeonato}</div>
                        {#each eventos[evt.nome_campeonato] as e, i}
                            <div class="destaque">
                                <Card shadow="sm" padding="lg"
                                    ><ModeloComprovante
                                        {logo1}
                                        logo2={e.imageUrl}
                                        evento={e.nome_campeonato}
                                        quando={e.quando}
                                        onde={e.onde}
                                        descricao={e.descricao_inscricao}
                                        data_inscricao={e.data_inscricao_formatada}
                                        data_pagamento={e.data_pagamento_efetiva}
                                        atletas={e.atletas}
                                        valor_pago={e.transaction_amount_formatado}
                                        cod_inscricao={e.cod_inscricao_encurtado}
                                        cod_inscricao_encurtado={e.cod_inscricao_encurtado}
                                        qr_code={e.cod_inscricao_encurtado}
                                        status_pagamento={e.status_pagamento}
                                        valor_desconto={e.preco_com_desconto_cupom_formatado}
                                        desconto={e.desconto_cupom_formatado}
                                        taxa={e.taxa_inscricao_formatado}
                                        preco={e.preco_formatado}
                                        certificado = {e.emite_certificado}
                                        ids = {e.ids}
                                        inscritos = {e.inscritos}
                                        inscritos_id = {e.inscritos_id}
                                        
                                        
                                        taxa_pag_cartao = {e.taxa_pag_cartao}
                                        taxa_pag_pix = {e.taxa_pag_pix}
                                        taxa_pag_boleto = {e.taxa_pag_boleto}

                                        taxa_pag_cartao_formatado = {e.taxa_pag_cartao_formatado}
                                        taxa_pag_pix_formatado = {e.taxa_pag_pix_formatado}
                                        taxa_pag_boleto_formatado = {e.taxa_pag_boleto_formatado}
                                    />
                                </Card>
                            </div>
                        {/each}
                    </Accordion.Item>
                {/each}
            </Accordion>
        </div>
    </div>
{:else}
    <h1>Você não tem inscrições</h1>
{/if}

<style>
    .branco {
        color: orange;
    }

    .destaque {
        overflow-y: auto; /* Adiciona scroll vertical se necessário */
        border: 1px solid #ccc; /* Contorno sombreado */
        border-radius: 5px; /* Borda arredondada */
        padding: 5px; /* Espaçamento interno */
        margin: 5px;
        background-color: transparent;
    }
</style>
